module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "landing"
    }
  }, [_c('div', {
    staticClass: "text-uppercase text-center",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500",
      "id": "square"
    }
  }, [_c('h1', [_vm._v("\n      celebrando 10 años de trayectoria\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#nosotros"
    }
  }, [_vm._v("conoce nuestra historia")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c27f1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 78
// module chunks = 0